// Utils
import registerLine from '../../../common/lines/index';

// Components
import presentationalComponent from './LinePresentationalWrapper';
import containerComponent from './LineContainer';

// Constants
import { TOOLS } from '../../workspace/toolbar/toolbarConstants';
import { TOOLBAR_TOOLS } from '../../workspace/toolbarV2/config/toolbarToolConfig';

export default () =>
    registerLine({
        containerComponent,
        presentationalComponent,
        tools: [TOOLS.COLOR, TOOLS.START_ARROW, TOOLS.END_ARROW, TOOLS.LINE_LABEL, TOOLS.LINE_STYLE, TOOLS.LINE_WEIGHT],
        selectedTools: [
            TOOLBAR_TOOLS.COLOR,
            TOOLBAR_TOOLS.START_ARROW,
            TOOLBAR_TOOLS.END_ARROW,
            TOOLBAR_TOOLS.LINE_LABEL,
            TOOLBAR_TOOLS.LINE_STYLE,
            TOOLBAR_TOOLS.LINE_WEIGHT,
            TOOLBAR_TOOLS.ALIGNMENT,
            TOOLBAR_TOOLS.DISTRIBUTE,
        ],
    });
